<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-purple-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
            </path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Inscripciones por Proyecto
          </h1>
          <p class="text-gray-600 mt-1">Descarga inscripciones individuales y corporativas en un solo Excel</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      <div class="bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2z">
            </path>
          </svg>
          Configuración del Reporte
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione filtros opcionales para generar el reporte</p>
      </div>

      <div class="p-6">
        <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Proyecto</label>
              <p-dropdown formControlName="projectId" [options]="projectsDropdown" [showClear]="true" [filter]="true"
                placeholder="Seleccionar proyecto" optionLabel="label" optionValue="value"
                (onFilter)="onSearchProjects($event)" class="w-full custom-dropdown">
              </p-dropdown>
              <p class="text-xs text-gray-500 mt-1">*Excluyente con Período</p>
            </div>
            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Período</label>
              <p-dropdown formControlName="period" [options]="months" [showClear]="true" placeholder="Seleccionar mes"
                optionLabel="label" optionValue="value" class="w-full custom-dropdown">
              </p-dropdown>
              <p class="text-xs text-gray-500 mt-1">*Excluyente con Proyecto</p>
            </div>
            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Participante</label>
              <p-dropdown formControlName="participantId" [options]="participantsDropdown" [showClear]="true"
                [filter]="true" placeholder="Seleccionar participante" optionLabel="label" optionValue="value"
                (onFilter)="onSearchParticipants($event)" class="w-full custom-dropdown">
              </p-dropdown>
            </div>
            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Empresa</label>
              <p-dropdown formControlName="companyId" [options]="companiesDropdown" [showClear]="true" [filter]="true"
                placeholder="Seleccionar empresa" optionLabel="label" optionValue="value"
                (onFilter)="onSearchCompanies($event)" class="w-full custom-dropdown">
              </p-dropdown>
            </div>
          </div>

          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
              <div>
                <span class="font-medium text-gray-600">Proyecto:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.projectId || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Período:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.period || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Participante:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.participantId || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Empresa:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.companyId || 'Todas' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Hojas:</span>
                <span class="ml-2 text-gray-800">Individual, Corporativa, Cuotas Pagadas</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Tipo:</span>
                <span class="ml-2 text-purple-600 font-medium">Inscripciones por Proyecto</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col sm:flex-row justify-end gap-4">
            <button type="submit" [disabled]="reportForm.invalid || loading"
              class="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">
              <div *ngIf="loading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Generando Excel...</span>
              </div>
              <div *ngIf="!loading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z">
                  </path>
                </svg>
                <span>Descargar Excel</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

  </div>
</div>